import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  ActiveBatchDetailsReport,
  ActiveBatchDetailsReportVariables
} from "./types/ActiveBatchDetailsReport";
import {
  batchDetailsQuery,
  batchDetailsQueryVariables
} from "./types/batchDetailsQuery";
import { BatchesQuery, BatchesQueryVariables } from "./types/BatchesQuery";
import { PayablesList, PayablesListVariables } from "./types/PayablesList";

export const batchesList = gql`
  ${pageInfoFragment}
  query BatchesQuery(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: BatchesFilterInput
  ) {
    batches(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          coverage_start_date
          coverage_end_date
          credit_date
          generated_at
          id
          mall_code
          mall_name
          status
        }
      }
    }
  }
`;

export const useBatchesQuery = makeBossQuery<
  BatchesQuery,
  BatchesQueryVariables
>(batchesList);

export const batcheDetails = gql`
  query batchDetailsQuery($id: ID!) {
    batchDetails(id: $id) {
      data {
        batch_id
        net_settlement
        settlement_date
        coverage_start_date
        coverage_end_date
        date_generated
        created_by_id
        status
        brand_name
        company_name
        mall_name
        mall_code
        created_by
      }
    }
  }
`;

export const useBatchDetailsQuery = makeBossQuery<
  batchDetailsQuery,
  batchDetailsQueryVariables
>(batcheDetails);

const ActiveBatchDetailsReportQuery = gql`
  query ActiveBatchDetailsReport($ids: [ID]!) {
    activeBatchDetailsReport(ids: $ids) {
      edges {
        node {
          id
          created
          completed_at
          mall_name
          legal_name
          brand_name
          total_retail_price
          sale_discount_tenant
          sale_discount_sm
          sale_discount_total
          subtotal
          shipping_cost
          total_gross_transaction
          voucher_discount_tenant
          voucher_discount_sm
          discount_amount
          price_paid
          payment_fee
          payment_fee_vat
          payment_fee_adjustment
          payment_fee_adjustment_vat
          total_payment_fee
          payment_fee_witholding_tax
          delivery_fee_adjustment
          credit_card_witholding_tax
          other_adjustment
          net_settlement
          settlement_date
          mall_code
          vendor_code
          rejection_reason
        }
      }
    }
  }
`;

export const useActiveBatchDetailsReportQuery = makeBossQuery<
  ActiveBatchDetailsReport,
  ActiveBatchDetailsReportVariables
>(ActiveBatchDetailsReportQuery);

const PayablesListQuery = gql`
  query PayablesList($ids: [ID]!) {
    payablesList(ids: $ids) {
      totalCount
      edges {
        node {
          id
          batch_id
          mall_name
          mall_code
          company_name
          brand_name
          net_settlement
          coverage_start_date
          coverage_end_date
          settlement_date
          status
          date_generated
          vendor_code
        }
      }
    }
  }
`;

export const usePayablesListQuery = makeBossQuery<
  PayablesList,
  PayablesListVariables
>(PayablesListQuery);
